module.exports = __webpack_public_path__ + "fonts/AvenirLight.715bb10.ttf";